module.exports = __webpack_public_path__ + "img/main-september_m.eb054afd.jpg";